import PropTypes from 'prop-types';
import { Checkbox } from 'components/UI/Checkbox/Checkbox';
import { Callout } from 'components/UI/Callout/Callout';

export const RegistrationFormFooter = (props) => {
  const {
    isProcessing,
    submitButtonDisabled,
    errorMessage,
    bottomErrorMessage,
    complexErrorMessage,
    successMessage,
    subscribeToNewsletters,
    setSubscribeToNewsletters,
  } = props;

  const handleSuscribeToNewsletter = (event) => {
    const checkboxIsChecked = event.target.checked;
    setSubscribeToNewsletters(checkboxIsChecked);
  };

  return (
    <>
      <div className="callout-container callout-info">
        <label className="static-label">Hear more about future events and offers</label>

        <Checkbox
          checkboxChangeHandler={(event) => handleSuscribeToNewsletter(event)}
          label="Subscribe to Arts Centre Melbourne for the latest event news, program announcements and offers."
          isChecked={subscribeToNewsletters}
          muiProps={{ id: 'signupACM', name: 'signupACM2' }}
        />
      </div>

      {(errorMessage || bottomErrorMessage || complexErrorMessage) && (
        <Callout errorMessage={bottomErrorMessage} />
      )}

      {successMessage && <Callout successMessage={successMessage} />}
      <br />

      <button
        type="submit"
        className="btn btn-primary"
        disabled={isProcessing || submitButtonDisabled}
      >
        <span>{isProcessing ? 'Processing...' : 'Register account'}</span>
      </button>
    </>
  );
};

RegistrationFormFooter.propTypes = {
  isProcessing: PropTypes.bool,
  submitButtonDisabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  bottomErrorMessage: PropTypes.string,
  complexErrorMessage: PropTypes.string,
  successMessage: PropTypes.string,
  subscribeToNewsletters: PropTypes.bool,
  setSubscribeToNewsletters: PropTypes.func,
};
